<template>
  <section v-if="shouldRender" :id ref="galleryEl">
    <BlokkliField
      class="paragraph-grid grid grid-cols-12 gap-size-6"
      :class="[
        !parentType && 'container mt-spacing-lg',
        // The bottom padding stays part of the grid field (not the columns), so
        // there's always an exposed area to drop new columns into, even when the
        // columns themselves fill the row.
        isEditing && 'min-h-24 pb-16',
      ]"
      name="field_columns"
      :list="filterNullArray(columns)"
      :should-render-item
    />
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphGridFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

const props = defineProps<{
  columns?: ParagraphGridFragment['columns']
}>()

const { parentType, index, siblings } = defineBlokkli({
  bundle: 'grid',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  editor: {
    disableEdit: true,
  },
  propsFieldMapping: {
    columns: { type: 'field', name: 'field_columns' },
  },
})

const id = useParagraphAnchorId(index, siblings)
const isEditing = false
const { isMobile } = useViewport()
const galleryEl = ref<HTMLElement>()

const { shouldRenderItem } = useParagraphVisiblity()

// Fullscreen PhotoSwipe gallery on mobile only (layout stays a CSS grid).
const isLightboxEnabled = computed(() => isMobile.value && !isEditing)

provideParagraphContext('gridLightbox', isLightboxEnabled)

// Links are only rendered when isLightboxEnabled is true, so desktop / editing
// stay non-interactive even though PhotoSwipe is bound to the section.
await useLightbox(galleryEl)

const shouldRender = computed(() => props.columns?.length || isEditing)
</script>
